<div *ngIf="prikaziStranicu" class="container-fluid">
    <h2 class="content-block">DIGITALNA PLOČA</h2>

    <div class="content-block">
        <dx-tab-panel
			#tabPanel
			[height]="'auto'"
			[dataSource]="tabovi"
			[selectedIndex]="0"
			[loop]="false"
			[animationEnabled]="true"
			[swipeEnabled]="true">

			<div *dxTemplate="let tab of 'title'">
				<span>{{ tab.naziv }}</span>
			</div>
            <div *dxTemplate="let tab of 'item'">
                <div class="tabpanel-item tabovi">
                    <div *ngIf="tab.id == 1">
                        <div class="customTable popisDjelatnika">
                            <dx-data-grid
                                [dataSource]="sveObavijesti"
                                [wordWrapEnabled]="true"
                                noDataText="{{ poruka }}"
                                keyExpr="idobavijest"
                                [showBorders]="false"
                                [showColumnLines]="true"
                                [columnAutoWidth]="true"
                                (onToolbarPreparing)="onToolbarPreparing($event)"
                                (onInitNewRow)="onInitNewRow($event)"
                                (onEditingStart)="onEditingStart($event)"
                                (onRowInserted)="dodajObavijest($event)"
                                (onRowUpdated)="urediObavijest($event)"
                                (onRowRemoved)="obrisiObavijest($event)"
                                >
                                <div *dxTemplate="let data of 'naslovTablice'" class="grid-wrapper">
                                    <div class="naslov">
                                        <h2 class="mb-0" style="padding-right: 30px">Obavijesti</h2>
                                        <p class="mt-0">Popis dodanih obavijesti</p>
                                    </div>
                                </div>

                                <dxo-search-panel
                                    [visible]="true"
                                    [width]="180"
                                    placeholder="Pretraži..."
                                >
                                </dxo-search-panel>

                                <dxo-paging [enabled]="true" [pageSize]="15"></dxo-paging>

                                <dxo-pager
                                    [showPageSizeSelector]="true"
                                    [allowedPageSizes]="[15, 30, 45]"
                                    [showInfo]="true"
                                >
                                </dxo-pager>

                                <dxo-editing 
                                    mode="popup" 
                                    [allowAdding]="true"
                                    [allowUpdating]="true"
                                    [allowDeleting]="true">
                                    
                                    <dxo-popup
                                        [onShowing]="onShowing"
                                        [showTitle]="true"
                                        title=""
                                        [maxWidth]="900"
                                        [height]="'auto'">
                                    </dxo-popup>

                                    <dxo-form [colCount]="1">
                                        <dxi-item dataField="ob_datum"></dxi-item>
                                        <dxi-item dataField="ob_naslov"></dxi-item>
                                        <dxi-item dataField="ob_sadrzaj" editorType="dxTextArea" [editorOptions]="{ stylingMode: 'outlined',  width: 'auto' }"></dxi-item>
                                        <dxi-item [label]="{text: 'Datoteka'}">
                                            <input *ngIf="prikazi_gumb" type="file" (change)="fileChangeSlika($event)" #fileInputSlika accept=".jpeg, .jpg, .jpe, .jfif, .jif, .png">
                                            <!-- <button (click)="fileInputSlika.click()">Odaberi datoteku</button>  -->
                                            <button *ngIf="!prikazi_gumb" (click)="obrisiFile()">Obriši privitak</button>
                                        </dxi-item>
                                    </dxo-form>
                                </dxo-editing>

                                <dxi-column
                                    dataField="redni_broj"
                                    caption="Rb."
                                    [width]="80"
                                ></dxi-column>
                                <dxi-column
                                    dataField="ob_datum"
                                    dataType="date"
                                    caption="Datum"
                                    [width]="120"
                                    alignment="left"
                                ></dxi-column>
                                <dxi-column
                                    dataField="ob_naslov"
                                    caption="Naslov"
                                    [width]="300"
                                ></dxi-column>
                                <dxi-column
                                    dataField="ob_sadrzaj"
                                    caption="Sadržaj"
                                ></dxi-column>
                                <dxi-column caption="Dokument" cellTemplate="slikaa">
                                    <div *dxTemplate="let data of 'slikaa'">
                                        <a class="slika" href="{{URL}}/datoteke/digitalnaploca/URL={{data.data.ud_putanja}}?access_token={{access_token}}" target="_blank" title="Pogledaj">
                                            {{ data.data.ud_nazivdokumenta_orig }}
                                        </a>
                                    </div>
                                </dxi-column>
                                <dxi-column
                                    dataField="korisnik_dodao"
                                    caption="Dodao"
                                ></dxi-column>
                                <dxi-column
                                    dataField="ob_danisat"
                                    dataType="datetime"
                                    caption="Datum i vrijeme dodavanja"
                                    [width]="170"
                                    alignment="left"
                                ></dxi-column>
                                <dxi-column
                                    dataField="korisnik_izmjene"
                                    caption="Izmjenio"
                                ></dxi-column>
                                <dxi-column
                                    dataField="ob_datumizmjene"
                                    dataType="datetime"
                                    caption="Datum i vrijeme izmjene"
                                    [width]="170"
                                    alignment="left"
                                ></dxi-column>
                                <dxi-column type="buttons" alignment="center" [fixed]="true" fixedPosition="right"></dxi-column>
                            </dx-data-grid>
                        </div>
                    </div>
                    <div *ngIf="tab.id == 2">
                        <div class="customTable popisDjelatnika">
                            <dx-data-grid
                                [dataSource]="sviDokumenti"
                                [wordWrapEnabled]="true"
                                noDataText="{{ poruka }}"
                                keyExpr="iddokument"
                                [showBorders]="false"
                                [showColumnLines]="true"
                                [columnAutoWidth]="true"
                                (onToolbarPreparing)="onToolbarPreparing($event)"
                                (onInitNewRow)="onInitNewRow2($event)"
                                (onRowInserted)="dodajDokument($event)"
                                (onRowRemoved)="obrisiDokument($event)"
                                >
                                <div *dxTemplate="let data of 'naslovTablice'" class="grid-wrapper">
                                    <div class="naslov">
                                        <h2 class="mb-0" style="padding-right: 30px">Dokumenti</h2>
                                        <p class="mt-0">Popis dodanih dokumenata</p>
                                    </div>
                                </div>

                                <dxo-search-panel
                                    [visible]="true"
                                    [width]="180"
                                    placeholder="Pretraži..."
                                >
                                </dxo-search-panel>

                                <dxo-paging [enabled]="true" [pageSize]="15"></dxo-paging>

                                <dxo-pager
                                    [showPageSizeSelector]="true"
                                    [allowedPageSizes]="[15, 30, 45]"
                                    [showInfo]="true"
                                >
                                </dxo-pager>

                                <dxo-editing 
                                    mode="popup" 
                                    [allowAdding]="true"
                                    [allowUpdating]="false"
                                    [allowDeleting]="true">
                                    
                                    <dxo-popup
                                        [onShowing]="onShowing"
                                        [showTitle]="true"
                                        title=""
                                        [maxWidth]="500"
                                        [height]="'auto'">
                                    </dxo-popup>

                                    <dxo-form [colCount]="1">
                                        <dxi-item dataField="do_naziv"></dxi-item>
                                        <dxi-item [label]="{text: 'Datoteka'}">
                                            <input type="file" (change)="fileChangeDoc($event)" #fileInput accept=".doc, .pdf, .xls, .xlsx">
                                            <!-- <button (click)="fileInput.click()">Odaberi datoteku</button>  -->
                                        </dxi-item>
                                    </dxo-form>
                                </dxo-editing>

                                <dxi-column
                                    dataField="redni_broj"
                                    caption="Rb."
                                    [width]="80"
                                ></dxi-column>
                                <dxi-column
                                    dataField="do_naziv"
                                    caption="Naziv"
                                ></dxi-column>
                                <dxi-column caption="Dokument" cellTemplate="cellDokument">
                                    <div *dxTemplate="let data of 'cellDokument'">
                                        <a class="dokument" href="{{URL}}/datoteke/digitalnaploca/URL={{data.data.ud_putanja}}?access_token={{access_token}}" target="_blank" title="Pogledaj">
                                            {{ data.data.ud_nazivdokumenta_orig }}
                                        </a>
                                    </div>
                                </dxi-column>
                                <dxi-column
                                    dataField="korisnik_dodao"
                                    caption="Dodao"
                                ></dxi-column>
                                <dxi-column
                                    dataField="do_danisat"
                                    dataType="datetime"
                                    caption="Datum i vrijeme dodavanja"
                                    [width]="170"
                                    alignment="left"
                                ></dxi-column>
                                <dxi-column type="buttons" alignment="center" [fixed]="true" fixedPosition="right"></dxi-column>
                                <!--
                                <dxi-column cellTemplate="uredjivanje" [width]="120" alignment="left" >
                                    <div *dxTemplate="let data of 'uredjivanje'">
                                        <dx-button
                                            [disabled]="pravaZaTrenutniPogled != 2"
                                            icon="edit"
                                            hint="Uredi"
                                            (onClick)="urediDokumentPopup(data)"
                                        >
                                        </dx-button>
                                        <dx-button
                                            [disabled]="pravaZaTrenutniPogled != 2"
                                            *ngIf="popisAktivnih"
                                            icon="trash"
                                            hint="Brisanje dokumenta"
                                            (onClick)="obrisiDokumentPopup(data)"
                                        >
                                        </dx-button>
                                    </div>
                                </dxi-column>
                                -->
                            </dx-data-grid>
                        </div>
                    </div>
                </div>
            </div>
        </dx-tab-panel>
    </div>
</div>
